import Vue from "vue";
import router from "@/router";
import store from "@/store";
import privilege from "./privilege";
import authPlugin from "@/plugins/auth";
import { getQueryObject } from "@/utils"
import { getTuiTuiSSO } from "@/config";

console.log('auth-store',store)

/**
 * @var{string} LOGIN_URL The endpoint for logging in. This endpoint should be proxied by Webpack dev server
 *    and maybe nginx in production (cleaner calls and avoids CORS issues).
 */
const LOGIN_URL = "../token";

/**
 * @var{string} LOGIN_URL The endpoint for logging in. This endpoint should be proxied by Webpack dev server
 *    and maybe nginx in production (cleaner calls and avoids CORS issues).
 */
const REFRESH_TOKEN_URL = "../token";

let isRefreshing = false; // 标记是否正在刷新token
let refreshSubscribers = [];


// let iframe = document.querySelector('.iframe-quotation')
// if (iframe) { // 在采购页
//   iframe.onload = function() {
//     // 告诉iframe，我先请求signon了
//     if (isGetToken) {
//       isGetToken = false
//       iframe.contentWindow.postMessage('isGetToken', '*')
//     }
//   }
// }

/**
 * Auth Plugin
 *
 * (see https://vuejs.org/v2/guide/plugins.html for more info on Vue.js plugins)
 *
 * Handles login and token authentication using OAuth2.
 */
export default {
  /**
   * Install the Auth class.
   * Creates a axios http interceptor to handle automatically adding auth headers
   * and refreshing tokens. Then attaches this object to the global Vue (as Vue.auth).
   * @param {Object} Vue The global Vue.
   * @param {Object} options Any options we want to have in our plugin.
   * @return {void}
   */
  install(Vue, options) {
    var that = this;
    Vue.http.interceptors.request.use(
      function (config) {
        const accessToken = store.state.auth.accessToken || "";
        if (accessToken.length > 0) {
          config.headers.Authorization = "Bearer " + (localStorage.getItem('CRM_TOKEN') || accessToken)
        }
        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

   
    Vue.http.interceptors.response.use(
      function (response) {
        return response;
      },
      async function (error) {
        if (that._isConflictToken(error.response)) {
          that.logout();
          return Promise.reject(
            "您的账号在其他地方登录，如果不是你本人操作，请尽快修改登录密码"
          );
        }
        // Do something with response error
        let { appid } = getQueryObject(location.href)
        // console.log('appid',appid)
        const auth = store.state.auth;
        const isTeams = store.state.hiddenHeader && appid
        console.log('isTeams',isTeams)
        console.log('auth.isLoggedIn',auth.isLoggedIn)
        if (auth.isLoggedIn) {
          // web
          if (!isTeams) {
            if (that._isInvalidToken(error.response)) {
              return that._refreshToken(error.config);
            }else if (that._isInvalidGrant(error.response)) {
              return that.logout();
            }
          }else { // teams
            const { response } = error;
            const originalRequest = error.config;

            // 如果响应状态是401
            if (response && response.status === 401 && !originalRequest._retry) {

              if (isRefreshing) {
                // 如果已经在刷新令牌，将请求加入等待队列
                return new Promise((resolve, reject) => {
                  refreshSubscribers.push({ resolve, reject });
                }).then(newToken => {
                  originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                  return Vue.http(originalRequest);
                }).catch(err => {
                  return Promise.reject(err);
                });
              }
        
              originalRequest._retry = true; // 标记为已重试
              isRefreshing = true;
        
              try {
                // 在这里处理刷新令牌逻辑，例如调用刷新令牌的 API
                const newToken = await that._refreshTeamsToken(); // 假设你有刷新令牌的函数
        
                // 更新请求头中的 Authorization
                originalRequest.headers['Authorization'] = `Bearer ${newToken}`;

                // await that.fetchUserInfo(); // 获取用户信息
        
                // 重新发起请求
                const result = await Vue.http(originalRequest);
        
                // 通知所有等待的请求新的令牌
                refreshSubscribers.forEach(subscriber => subscriber.resolve(newToken));
                refreshSubscribers = [];
        
                return result;
              } catch (refreshError) {
                // 如果刷新令牌失败，可以跳转到登录页面或进行其他处理
                console.error('token获取失败', refreshError);
        
                // 通知所有等待的请求刷新失败
                refreshSubscribers.forEach(subscriber => subscriber.reject(refreshError));
                refreshSubscribers = [];
        
                return Promise.reject(refreshError);
              } finally {
                isRefreshing = false;
              }
            }

            return Promise.reject(error);
          }
        }

        return Promise.reject(error.response); // 错误提示了

      }
    );

    // 添加 $auth 插件到Vue的全局对象上
    Vue.prototype.$auth = Vue.auth = this;
  },

  /**
   * Login
   * @param {Object.<string>} userInfo The username and password for logging in.
   * @return {Promise}
   */
  login(creds, redirect, grant_type = "password") {
    const data =
      "grant_type=password&username=" +
      encodeURIComponent(creds.username) +
      "&password=" +
      creds.password +
      "&captcha1=" +
      encodeURIComponent(creds.captcha1) +
      "&captcha2=" +
      creds.captcha2;
    return Vue.http.post(LOGIN_URL, data).then((response) => {
      // 保存登陆信息
      this._storeToken(response);

      if (redirect) {
        router.push({
          name: redirect,
        });
      }

      return response.data;
    });
  },

  /**
   * Login
   * @param {Object.<string>} userInfo The mobilePhone for logging in.
   * @return {Promise}
   */
  sms_login(creds, redirect) {
    const data =
      "grant_type=smscode&mobilephone=" +
      encodeURIComponent(creds.mobilephone) +
      "&captcha1=" +
      encodeURIComponent(creds.captcha1);
    return Vue.http.post(LOGIN_URL, data).then((response) => {
      // 保存登陆信息
      this._storeToken(response);

      if (redirect) {
        router.push({
          name: redirect,
        });
      }

      return response.data;
    });
  },

  tuitui_login(data) {
    const url = "/api/api-uaa/oauth/app/cc/sign_on";
    console.log('tuitui_login_isLoggedIn',store.state.auth.isLoggedIn)
    
    if (!store.state.auth.isLoggedIn) { // 初次登陆
      console.log('初始登陆')
      return Vue.http
      .post(url, data)
      .then((response) => {
        if (response.data.code != 200) {
          rt.showErrorToast('登录失败，请联系渠道运营人员或反馈至fankui@360.cn');
          return Promise.reject('登录失败');
        }
        // 获取crm_token
        const result = {
          data: {
            access_token: response.data.data.crm_token,
            refresh_token: response.data.data.crm_token,
            zqt_token: response.data.data.zqt_token,
          },
        };
        this._storeToken(result);
        return response.data;
      })
      // .then(async () => {
      //   console.log('tuitui_login-fetchUserInfo')
      //   await this.fetchUserInfo()
      // })
      .catch(err => {
        console.log(err)
        throw new Error('登录失败'); // 登录失败，抛出异常
      })
      
    }else {
      console.log("已登陆")
    }

  },

  clearAllData() {
    store.commit("CLEAR_ALL_DATA");
    privilege.reset();
  },

  /**
   * Logout
   * Clear all data in our Vuex store (which resets logged-in status) and redirect back to login form.
   * @return {void}
   */
  logout() {
    Vue.http.post("../api/portaluser/logout").finally(() => {
      this.clearAllData();

      router.push({
        name: "home",
      });
    });
  },

  /**
   * Retry the original request.
   * Let's retry the user's original target request that had recieved a invalid token response
   * (which we fixed with a token refresh).
   * @param {Request} request The axios Request instance to use to repeat an http call.
   * @return {Promise}
   */
  _retry(config) {
    return Vue.http.request(config);
  },

  /**
   * Refresh the access token
   * Make an ajax call to the OAuth2 server to refresh the access token (using our refresh token).
   * @private
   * @param {Request} request Vue-resource Request instance, the original request that we'll retry.
   * @return {Promise}
   */
  _refreshToken(config) {
    const params =
      "grant_type=refresh_token&refresh_token=" + (localStorage.getItem('refreshToken') || store.state.auth.refreshToken);

    return Vue.http
      .post(REFRESH_TOKEN_URL, params)
      .then((resp) => {
        this._storeToken(resp);
        return this._retry(config);
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  async fetchUserInfo() {
    return rt.get("../api/PortalUser/userInfo")
      .then((res) => {
        // 缓存用户信息
        console.log('获取用户信息',res)
        if (res && res.UserName) {
          let user = {
            userId: res.SystemUserId,
            userName: res.UserCode,
            nickName: res.UserName,
            loginType: res.LoginType,
            avatarUrl: res.AvatarUrl,
            departName: res.OutterUserDepartName,
            departId: res.OutterUserDepartId,
            userType: res.UserType,
          };
          store.commit("UPDATE_USER", user);
        }
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },
  handleSignOn(query) {
    return Vue.http
      .post('/api/api-uaa/oauth/app/cc/sign_on', {
        ...query,
        channel: "crm",
      })
      .then(async (response) => {
        // 获取token失败
        if (response.data.code != 200) {
          rt.showErrorToast('登录失败，请联系渠道运营人员或反馈至fankui@360.cn.');
          return
        }
        // 获取crm_token
        const result = {
          data: {
            access_token: response.data.data.crm_token,
            refresh_token: response.data.data.crm_token,
            zqt_token: response.data.data.zqt_token,
          },
        };
        this._storeToken(result);

        return response.data.data.crm_token

      })
  },
  async _refreshTeamsToken(config) {
    console.log('_refreshTeamsToken')

    const tuituiScript = document.getElementById('tuituiScript')
    // 客户端推推凭证过期，重新获取
    if (tuituiScript) {

      if (window.cc && window.cc.teams && window.cc.teams.util && window.cc.teams.util.getSsoParams) {
        let { appid } = getQueryObject(location.href)
        try {
          const ssoRes = await getTuiTuiSSO(appid)
          return this.handleSignOn(ssoRes)  
        } catch (error) {
          rt.showErrorToast('获取推推参数失败');
        }
      }else {
        console.log('没有客户端API方法')
        return this.handleSignOn(getQueryObject(location.href))
      }
      
    }else {
      return this.handleSignOn(getQueryObject(location.href))
    }
    
  },

  /**
   * Store tokens
   * Update the Vuex store with the access/refresh tokens received from the response from the Oauth2 server.
   * @private
   * @param {Response} response axios Response instance from an OAuth2 server. that contains our tokens.
   * @return {void}
   */
  _storeToken(response) {
    const auth = store.state.auth;

    auth.isLoggedIn = true;
    auth.accessToken = response.data.access_token;
    auth.refreshToken = response.data.refresh_token;
    auth.zqtToken = response.data.zqt_token;
    localStorage.setItem('refreshToken',auth.refreshToken)

    store.commit("UPDATE_AUTH", auth, store.state.hiddenHeader);
  },

  /**
   * Check if the axios Response is an invalid token response.
   *
   * @private
   * @param {Response} response The axios Response instance received from an http call.
   * @return {boolean}
   */
  _isInvalidToken(response) {
    // 添加空值检查，防止 response 为 undefined
    if (!response) {
      return false;
    }
    const status = response.status;
    const error = response.statusText;
    return (
      status == 401 && (error == "invalid_token" || error == "expired_token" || error == "")
    );
  },

  _isInvalidTeamsToken(response) {
    // 添加空值检查，防止 response 为 undefined
    if (!response) {
      return false;
    }
    console.log('_isInvalidTeamsToken')
    const status = response.status;
    // const error = response.statusText;
    return (
      status == 401
    );
  },

  _isInvalidGrant(response) {
    // 添加空值检查，防止 response 为 undefined
    if (!response) {
      return false;
    }
    const config = response.config
    const status = response.status;
    const error = response.statusText;
    // 添加对 config.data 的安全检查
    const hasRefreshToken = config.data && config.data.includes('grant_type=refresh_token');
    return (
      status == 400 && (error == "Bad Request") && hasRefreshToken
    );
  },

  _isConflictToken(response) {
    // 添加空值检查，防止 response 为 undefined
    if (!response) {
      return false;
    }
    const status = response.status;
    return status == 409;
  },
};



// WEBPACK FOOTER //
// ./src/plugins/auth.js